import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import StatusCell from "./StatusCell";
import ActionsCell from "./ActionCell";
import UpdateDetailsModal from "./UpdateDetailsModal";

const NotifiicationsDataTable = ({ data, refreshData }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedUpdateId, setSelectedUpdateId] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedUpdateData, setSelectedUpdateData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // Add this new function
  const handleShowDetails = (update) => {
    setSelectedUpdateData(update);
    setShowDetailsModal(true);
  };

  const handleActionClick = (updateId, action) => {
    setSelectedUpdateId(updateId);
    setSelectedAction(action);
    setShowConfirmation(true);
  };

  const handleConfirmAction = async () => {
    if (selectedAction === "reject" && !rejectionReason) {
      return;
    }
    setIsLoading(true);
    const { response } = await Helper.Get({
      url: `${api_Routes.Orders.ProcessUpdated}/${selectedUpdateId}/${selectedAction}`,
      hasToken: true,
      data: selectedAction === "reject" ? { reason: rejectionReason } : {},
    });

    if (response) {
      refreshData();
      handleCloseConfirmation();
    }
    setIsLoading(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    setSelectedAction(null);
    setSelectedUpdateId(null);
    setRejectionReason("");
  };

  return (
    <>
      <TableContainer component={Paper}>
        {/* Existing table code remains the same */}
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow className="bg-primary">
              {[
                "ID",
                "Title",
                "Link",
                "Status",
                "Actions",
              ].map((header) => (
                <TableCell
                  key={header}
                  align="center"
                  className="!text-darkTextColor"
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((update) => (
              <TableRow key={update.id}>
                <TableCell align="center">{update.id}</TableCell>
                <TableCell align="center">{update.description?.text}</TableCell>
                <TableCell align="center">{update.description?.link}</TableCell>
                <TableCell align="center">{update.is_read ? "Read" : "un Read"}</TableCell>
                <ActionsCell
                  update={update}
                  handleShowDetails={handleShowDetails}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>


      {selectedUpdateData && (
        <UpdateDetailsModal
          setShowDetailsModal={setShowDetailsModal}
          showDetailsModal={showDetailsModal}
          selectedUpdateData={selectedUpdateData}
        />
      )}
    </>
  );
};

export default NotifiicationsDataTable;
